<template>
  <BittsTooltip placement="top" :mount-to-body="true">
    <BittsButton
      v-bind="$attrs"
      :center-icon="icon"
      :aria-label="label"
      :aria-expanded="isOpen"
      type="neutral"
      variant="ghost"
      size="small"
      @click="toggle"
    />
    <template #title>{{ tooltip }}</template>
  </BittsTooltip>
</template>

<script setup lang="ts">
import { BittsButton, BittsTooltip } from '@crossbeam/bitts';
import { IRP_CTAS } from '@crossbeam/itly';

import { computed } from 'vue';

import { useIRPTracking } from './useIRPTracking';

const { rowName } = defineProps<{
  rowName: string;
}>();

defineOptions({ inheritAttrs: false });

const isOpen = defineModel<boolean>('isOpen', { required: true });

const { trackIRPInteraction } = useIRPTracking();

const icon = computed<['fak', string]>(() =>
  isOpen.value ? ['fak', 'chevron-up'] : ['fak', 'chevron-down'],
);
const tooltip = computed(() => (isOpen.value ? 'Collapse' : 'Expand'));
const label = computed(() => `${tooltip.value} ${rowName}`);

function toggle() {
  trackIRPInteraction({
    cta: IRP_CTAS.OWN_DATA,
    cta_2: isOpen.value ? 'collapse' : 'expand',
  });
  isOpen.value = !isOpen.value;
}
</script>
